import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { LOCATIONS } from "@/lib/locationMeta";

export const Route = createFileRoute("/_app/locations/")({
  head: () =>
    buildHead({
      title: "Verified Scrap Yards & Foundry Buyers by City | LohaLink",
      description:
        "Browse GST-verified scrap yards and steel foundry buyers across 20 Indian industrial hubs — from Siliguri and Durgapur to Rajkot, Chennai and Hyderabad.",
      canonical: "/locations",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Scrap yards and foundry buyers by city — India",
          url: "https://lohalink.in/locations",
          mainEntity: {
            "@type": "ItemList",
            itemListElement: LOCATIONS.map((l, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: `Scrap yards in ${l.name}`,
              url: `https://lohalink.in/locations/${l.slug}`,
            })),
          },
        },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/Locations")),
});
